import { jsx, css } from '@emotion/react';
import { Typography, Colors } from '@zapier/design-system';
import { Heading } from 'react-aria-components';

const ModalContentHeaderStyles = ({ textAlign }) => css`
  ${Typography.ParagraphHeader3}
  margin-bottom: var(--zds-space-20, 20px);
  color: var(--zds-text-default, ${Colors.GrayWarm10});
  text-align: ${textAlign};
`;
const ModalContentHeader = ({ children, textAlign = "start" }) => {
  return jsx(Heading, { css: ModalContentHeaderStyles({ textAlign }), "data-zds": true, slot: "title" }, children);
};

export { ModalContentHeader };
//# sourceMappingURL=ContentHeader.es.js.map
